import { HeroSearchProps } from 'src/components/Hero/Search'
import { useTranslation } from 'react-i18next'
import Router, { routes } from 'src/routes/Router'
import * as Yup from 'yup'

const useSearchHero = ({
  previousTerms,
  locale,
}: {
  previousTerms: string
  locale: string
}): HeroSearchProps => {
  const { t } = useTranslation()

  return {
    title: t('searchPage.hero.title'),
    formikFormProps: {
      onSubmit: (v) => {
        Router.pushRoute(routes.search, { slug: v.term }, { locale })
      },
      initialValues: {
        term: previousTerms,
      },
      validationSchema: Yup.object().shape({
        term: Yup.string()
          .min(3, t('header.search.form.validation.min'))
          .required(t('yup.required')),
      }),
      enableReinitialize: true,
    },
    search: {
      placeholder: t('header.search.form.placeholder'),
      submitLabel: t('header.search.form.submitLabel'),
      resetLabel: t('header.search.form.resetLabel'),
    },
    linkProps: {
      text: t('searchPage.link.text'),
      href: Router.getRouteUrl(routes.home),
      locale,
    },
  }
}

export default useSearchHero
